import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InvoiceMenu from "./InvoiceMenu";
import config from "../../Config";

function EditInvoicePayment() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [validated, setValidated] = useState(false);
  const [invoice, setInvoice] = useState(null);

  const navigate = useNavigate();
  const params = useParams();
  const invoiceId = params.id;

  useEffect(() => {
    document.title = "Edit Invoice Payment";
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: invoiceId,
    };

    axios({
      method: "post",
      url: config.base_url + "PaymentInvoice/PrintInvoice",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setInvoice(response.data.InvoiceData);
        } else {
          toast.error(response.data.status_message || "Invoice not found.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [AccessKey, UserID, MemberType, invoiceId]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setSaving(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: parseInt(invoiceId, 10) || 0,
      PaymentStatus: form.PaymentStatus.value,
      PaymentDate: form.PaymentDate.value || null,
      PaymentConfirmationDate: form.PaymentConfirmationDate.value || null,
    };

    axios({
      method: "post",
      url: config.base_url + "PaymentInvoice/UpdateInvoicePayment",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/invoice/manage-invoice");
        } else {
          const msg =
            response.data.error_message ||
            response.data.status_message ||
            "Sorry, something went wrong.";
          toast.error(msg, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setSaving(false);
      })
      .catch(() => {
        setSaving(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });

    setValidated(true);
  };

  const toDateInputValue = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().slice(0, 10);
  };

  return (
    <>
      <InvoiceMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/invoice/manage-invoice">Invoice</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Invoice Payment
                  </li>
                </ol>
              </nav>
              <div className="page-title">Edit Invoice Payment</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/invoice/manage-invoice"
                  className="button button-white button-icon"
                >
                  Manage Invoice
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  {loading ? (
                    <Spinner animation="border" role="status"></Spinner>
                  ) : !invoice ? (
                    <div>No invoice found.</div>
                  ) : (
                    <Form
                      noValidate
                      validated={validated}
                      onSubmit={handleSubmit}
                    >
                      <div className="row align-items-center">
                        <div className="col-md-3">
                          <div className="form-group mb-3">
                            <label className="">Invoice Month:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={invoice.InvoiceMonth || ""}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-3">
                            <label className="">Invoice Year:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={invoice.InvoiceYear || ""}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-3">
                            <label className="">Invoice Amount:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={invoice.InvoiceAmount || 0}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-3">
                            <label className="">Payment Status:</label>
                            <select
                              className="form-select"
                              required
                              name="PaymentStatus"
                              defaultValue={invoice.PaymentStatus || "Pending"}
                            >
                              <option value="Pending">Pending</option>
                              <option value="Paid">Paid</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group mb-3">
                            <label className="">Payment Date:</label>
                            <input
                              type="date"
                              className="form-control"
                              name="PaymentDate"
                              defaultValue={toDateInputValue(invoice.PaymentDate)}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group mb-3">
                            <label className="">Payment Confirmation Date:</label>
                            <input
                              type="date"
                              className="form-control"
                              name="PaymentConfirmationDate"
                              defaultValue={toDateInputValue(
                                invoice.PaymentConfirmationDate
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-md-2 mt-md-2 text-end">
                          <div className="form-group">
                            {saving ? (
                              <Spinner animation="border" role="status"></Spinner>
                            ) : (
                              <button
                                type="submit"
                                value="Save"
                                className="button button-primary w-100"
                              >
                                SAVE
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditInvoicePayment;
